import { cn } from "../../utils/tailwindUtils";
import { getDepositMovementTrace } from "../../utils/depositStatementDisplay";

/** Movement type + linked original/reversal trace for deposit statement rows. */
export function DepositMovementTrace({ txn, employeeView = false, className }) {
    const { primaryLabel, lines } = getDepositMovementTrace(txn, { employeeView });

    return (
        <div className={className}>
            <span className={cn(!employeeView && "capitalize", "font-medium text-gray-900 dark:text-gray-100")}>
                {primaryLabel}
            </span>
            {lines.map((line) => (
                <span
                    key={line.text}
                    className={cn(
                        "block text-[11px] mt-0.5 leading-snug",
                        line.tone === "warning"
                            ? "text-amber-700 dark:text-amber-400"
                            : "text-muted-foreground",
                    )}
                >
                    {line.text}
                </span>
            ))}
        </div>
    );
}

/** Whether HR can still reverse this ledger row. */
export function canReverseDepositTxn(txn, depositStatus = "active") {
    return depositStatus === "active"
        && txn?.txn_type !== "reversed"
        && !txn?.is_reversed;
}
